import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "./assets/css/style.css"
// import VueSupabase from "vue-supabase";

// Vue.use(VueSupabase, {
//   supabaseUrl: "https://kongqlubxitgitfibcnj.supabase.co",
//   supabaseKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtvbmdxbHVieGl0Z2l0ZmliY25qIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTcwMjA3MTMsImV4cCI6MTk3MjU5NjcxM30.4D4ioA8riXCJnIMd6gaRxKFJxwclr6jYOP4b--4gK1k",
//   supabaseOptions: {},
// });

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
